export const CmConstants = {
    DocsAndLetters: {
        SourceMenuId: 202
    }, 
    Reports: {
        SourceMenuId: 201
    }, 
    TlushiPension: {
        SourceMenuId: 301
    },
    Doc101: {
        SourceMenuId: 302
    }
}